import { render, staticRenderFns } from "./WorkflowAPITriggerPlaceholder.vue?vue&type=template&id=85ddb8c6&"
import script from "./WorkflowAPITriggerPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./WorkflowAPITriggerPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports